'use client';
import useSWR from 'swr';
import { buildQueryString, QueryParameter } from '@/utils/shopSubdomain';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import {
  TypeBundleDiscount,
  TypePlayKitBundleOffers,
} from '@/lib/api/productCatalog/types';

type PlayKitBundleOffersParams = {
  language: string;
  currencyCode: string;
  productAnchor?: string;
  shouldFetch?: boolean;
};

export default function usePlayKitBundleOffers(
  params: PlayKitBundleOffersParams,
) {
  const queryParams: QueryParameter[] = [
    {
      key: 'starting_product_anchor',
      value: params?.productAnchor || '',
    },
    {
      key: 'language',
      value: params.language,
    },
    {
      key: 'currency_code',
      value: params.currencyCode,
    },
  ];

  const queryString = buildQueryString(queryParams);
  const uri = `${API_URLS.PRODUCT_CATALOG_PROXY}/discounts/bundles${queryString}`;

  const {
    data: playKitBundleOffersData,
    isLoading: playKitBundleOffersLoading,
    error: playKitBundleOffersError,
    mutate: mutatePlayKitBundleOffers,
  } = useSWR<TypePlayKitBundleOffers, Error>(
    params.shouldFetch ? uri : null,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    playKitBundleOffersData,
    playKitBundleOffersLoading,
    playKitBundleOffersError,
    mutatePlayKitBundleOffers,
  };
}
